export const parseDynamoItem = (item: any): any => {
  if (!item) return item;

  if (item.S !== undefined) return item.S;
  if (item.N !== undefined) return Number(item.N);
  if (item.L !== undefined) return item.L.map(parseDynamoItem);
  if (item.M !== undefined) {
    const obj: any = {};
    Object.keys(item.M).forEach((key) => {
      obj[key] = parseDynamoItem(item.M[key]);
    });
    return obj;
  }
  return item;
};
